/* jshint esversion: 6 */
import * as constants from 'app/redux/constants.js';

const UserMessages = {
	route: {
		created: "We'll check your feed for new items momentarily",
		reactivated: {
			curated: "Your feed has been reactivated and we'll curate the next new item found.",
			simple: {
				next: "Your feed has been reactivated and we'll share the next new item found.",
				new: "Your feed has been reactivated and we're sharing the most recent items.",
				mostRecent: "Your feed has been reactivated and we're sharing the most recent item."
			},
			advanced: {
				next: "Your route has been reactivated and we'll share the next new items found.",
				new: "Your route has been reactivated and we're sharing the most recent items from each feed.",
				mostRecent: "Your route has been reactivated and we're sharing the most recent item from each feed."
			}
		},
		onboarding: "Please finish setting up your source before continuing!"
	},
	social: {
		reauthorized: "We reconnected your social!",
		test: "Your social is connected."
	},
	shortener: {
		reauthorized: "We reconnected your shortener. Hit save to finish things up.",
		updated: "Your shortener has been updated",
		test: "Great, we've connected to your shortener."
	},
	input: {
		created: "Your feed has been added. Browse items from this feed below to Share or add to your Queue.",
		reauthorized: "We've got your input reconnected!"
	},
	domain: {
		updated: "Your domain has been updated"
	},
	post: {
		success : {
			next: "Looks good! We've added it to the top of your queue.",
			now: "Nicely done! We're posting it right now!",
			queue: "Great one! We've added it to your queue.",
			update: "We've got your changes!",
			schedule: "Nice one! We'll post your content right on time",
			everqueue: "We've added that post to your EverQueue.",
			everqueueEdit: "We've updated your EverQueue post."
		},
		error : {
			generic: 'Something went wrong',
			duplicate: "Whoa! It looks like you just recently posted that one. Try again later!",
			category: "The category you selected doesn't have scheduled times for one or more of your chosen socials."
		}
	},
	queue: {
		success : 'Superb! Your post is in good hands.',
		update: "We've updated your post!",
		error: {
			generic: 'Something went wrong',
			duplicate: "Whoa! It looks like that's already in your queue. Wait for it to post then try again."
		}
	},
	subaccount: {
		updated: "This user has been updated"
	},
	user: {
		updated: "Your account information has been updated",
		resendEmailConfirmation: "Your confirmation email has been resent"
	},
	app: {
		networkError: "We couldn't complete your last request due to a network error. Please try again.",
		networkErrorUrl: "We weren't able to retrieve that url in time. Please try again."
	},
	generateMessage: (message, type) => {
		return {
			id: new Date().getTime(),
			message,
			type,
			messageType: constants.MESSAGE_TYPE_INFO
		};
	},
	generateFlashMessage: (message, type) => {
		return {
			id: new Date().getTime(),
			message,
			type,
			messageType: constants.MESSAGE_TYPE_FLASH
		};
	}
};

export default UserMessages;
